import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayout10Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M7.5 12H9.25C10.2165 12 11 11.2165 11 10.25V1.75C11 0.783502 10.2165 0 9.25 0H7.5V12Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M2.75 0C1.7835 0 1 0.783502 1 1.75V3H6V0H2.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M1 4.5V7.5H6V4.5H1Z", fill: "currentColor" }),
        React.createElement("path", { d: "M1 9V10.25C1 11.2165 1.7835 12 2.75 12H6V9H1Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridLayout10Fill12.js.map